import { render, staticRenderFns } from "./V3SpesifikasiBarang.vue?vue&type=template&id=40f30cc7&"
import script from "./V3SpesifikasiBarang.vue?vue&type=script&lang=js&"
export * from "./V3SpesifikasiBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports